import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiService} from '../../api';

import {Entity} from './create-population.interfaces';

@Injectable()
export class CreatePopulationService {

  constructor(private api: ApiService) {
  }

  public getEntityList(url: string): Observable<Entity[]> {
    return this.api.get(url);
  }
}
